import { useEffect } from "react";

const ROBOTS_META_ID = "nafhub-robots-meta";

/**
 * Injects a `<meta name="robots">` tag into `document.head` on mount and removes it on unmount.
 * Use once per page only — do not call from multiple components on the same route. The hook
 * manages a single shared DOM element (`nafhub-robots-meta`) and does not support concurrent instances.
 */
export const useRobotsMetaTag = (content: string): void => {  useEffect(() => {
    if (document.getElementById(ROBOTS_META_ID)) {
      return;
    }

    const meta = document.createElement("meta");
    meta.id = ROBOTS_META_ID;
    meta.name = "robots";
    meta.content = content;
    document.head.appendChild(meta);

    return () => {
      document.getElementById(ROBOTS_META_ID)?.remove();
    };
  }, []);
};
